import { render, staticRenderFns } from "./EditProfileAsUser.vue?vue&type=template&id=2697487b"
import script from "./EditProfileAsUser.vue?vue&type=script&lang=js"
export * from "./EditProfileAsUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports